import React from 'react'

const ContentTextBlock = ({ text }) => (
  <div dangerouslySetInnerHTML={{__html: text}} />
)

export default ContentTextBlock
